import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import ConsulateRelease from './municipality-release';
import { FormikErrors, FormikTouched } from 'formik';
import TypeResidenceList from 'shell/components/shared/type-residence';
import { AccordionResidencyPermit as AccordionResidencyPermitVM } from 'shell/components/shared/sipo-person-form/new-person';

interface IdentityCardProps {
  values?: AccordionResidencyPermitVM;
  onChange: (
    key: keyof AccordionResidencyPermitVM,
    value: AccordionResidencyPermitVM[keyof AccordionResidencyPermitVM]
  ) => void;
  errors?: FormikErrors<AccordionResidencyPermitVM>;
  touched?: FormikTouched<AccordionResidencyPermitVM>;
}

const ResidencyPermitComponent = ({
  values,
  onChange,
  errors,
  touched,
}: IdentityCardProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Numero permesso *"
          aria-label="Numero permesso"
          id="permit-number"
          fullWidth
          onChange={(event) => {
            onChange('number', event?.target.value);
          }}
          inputProps={{
            maxLength: '20',
          }}
          value={values?.number || ''}
          helperText={errors?.number}
          error={touched?.number && Boolean(errors?.number)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TypeResidenceList
          label="Tipo *"
          aria-label="Tipo"
          onChange={(residence) => {
            onChange('type', residence);
          }}
          value={values?.type || ''}
          error={touched?.type && Boolean(errors?.type)}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Note"
          aria-label="Note"
          id="permit-note"
          fullWidth
          inputProps={{
            maxLength: '240',
          }}
          onChange={(event) => {
            onChange('note', event?.target.value);
          }}
          value={values?.note || ''}
          multiline
          rows={3}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data rilascio *"
          value={values?.releaseDate || null}
          onChange={(value) => {
            onChange('releaseDate', value || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="releaseDate"
              fullWidth
              helperText={errors?.releaseDate}
              error={touched?.releaseDate && Boolean(errors?.releaseDate)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data scadenza *"
          value={values?.expirationDate || null}
          onChange={(value) => {
            onChange('expirationDate', value || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="expirationDate"
              fullWidth
              helperText={errors?.expirationDate}
              error={touched?.expirationDate && Boolean(errors?.expirationDate)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <PmiTextField
          label="Questura rilascio *"
          aria-label="Questura rilascio"
          id="police-force-release"
          fullWidth
          inputProps={{
            maxLength: '50',
          }}
          onChange={(event) => {
            onChange('policeForceRelease', event?.target.value);
          }}
          value={values?.policeForceRelease || ''}
          helperText={errors?.policeForceRelease}
          error={touched?.policeForceRelease && Boolean(errors?.policeForceRelease)}
        />
      </Grid>
      <ConsulateRelease values={values} onChange={onChange} />
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Nr passaporto *"
          aria-label="Numero passaporto"
          id="passport-number"
          fullWidth
          inputProps={{
            maxLength: '30',
          }}
          onChange={(event) => {
            onChange('passportNumber', event?.target.value);
          }}
          value={values?.passportNumber || ''}
          helperText={errors?.passportNumber}
          error={touched?.passportNumber && Boolean(errors?.passportNumber)}
        />
      </Grid>
    </Grid>
  );
};

ResidencyPermitComponent.displayName = 'Accordion Residency Permit component';

const ResidencyPermit = memo(ResidencyPermitComponent);

export default ResidencyPermit;
